import { createLogic } from 'redux-logic'
import {
  CLEAR_PROGRAM_OPTIONS,
  CLEAR_CANCEL_PROGRAM_OPTIONS,
} from '../constants/programOptions'
import { PROGRAM_OPTIONS_TIMEOUT } from '../constants/timeouts'

const clearProgramOptionsLogic = createLogic({
  type: CLEAR_PROGRAM_OPTIONS,
  cancelType: CLEAR_CANCEL_PROGRAM_OPTIONS,
  warnTimeout: PROGRAM_OPTIONS_TIMEOUT,

  transform({ getState, action }, next) {
    const { programOptions: { selectedOption } } = getState()
    const programOptions = [{ number: parseInt(selectedOption, 10), value: '' }]

    next({
      ...action,
      programOptions,
    })
  },

  process({ action }, dispatch, done) {
    global.programOptionsChannel.perform('update_program_options', { programOptions: action.programOptions })
    done()
  },
})

export default clearProgramOptionsLogic
